var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWowza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.012 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE8605",
    d: "M13.008 9.344c.52-1.991 1.312-3.958 2.013-5.927.204-.542.859-1.267.204-1.719-.634-.43-1.131.362-1.606.746-1.222.95-2.42 1.991-3.642 2.986-.317.249-.657.701-1.064.43-.361-.271-.045-.701.091-1.018.611-1.425 1.244-2.828 1.854-4.23.182-.43.431-.611.928-.611 3.257-.045 6.039 1.041 8.438 3.212.361.316.633.588.09 1.063-1.99 1.742-3.958 3.551-5.926 5.361-.159.159-.363.272-.566.363-.701.361-.883.044-.814-.656z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE8503",
    d: "M8.37.703C6.945 3.802 5.565 6.81 4.186 9.818c-.181.407-.407.814-.542 1.244-.113.362-.227.769.135 1.041.34.271.725.181 1.063-.023.385-.226.77-.475 1.108-.769 1.471-1.221 2.94-2.488 4.411-3.709.294-.249.655-.746 1.04-.452.316.249.113.769-.045 1.153-1.357 3.303-2.715 6.605-4.049 9.93-.271.656-.95 1.381-.249 2.059.746.725 1.425-.045 2.036-.361 4.614-2.443 9.229-4.932 13.82-7.397.294-.158.61-.52.904-.339.362.226.136.679.113 1.041-.339 5.383-4.863 9.93-10.586 10.676-5.451.701-10.925-2.76-12.712-8.053-1.966-5.905.77-12.261 6.426-14.839C7.421.861 7.76.612 8.37.703z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWowza);
export default __webpack_public_path__ + "static/media/wowza.9c5dbf0d4fabf5a6071051c8c7a2a28a.svg";
export { ForwardRef as ReactComponent };